import angular from 'angular';
import 'angular-ui-router';
import 'angular-ui-router-title';
import GameDevelopersIndex from './gameDevelopersIndex';
import GameDevelopersForm from './gameDevelopersForm';
import GameDevelopersEdit from './gameDevelopersEdit';
import FeeForm from './feeForm';

export default angular.module('app.components.admin.gameDevelopers', [
  'ui.router',
  GameDevelopersIndex.name,
  GameDevelopersForm.name,
  GameDevelopersEdit.name,
  FeeForm.name
])
  .config(function($stateProvider, $urlRouterProvider){
    $stateProvider
      .state('app.admin.gameDevelopers', {
        abstract: true,
        url: '/gameDevelopers',
        template: '<ui-view/>',
        data: {
          permissions: {
            only: ['ADMIN', 'GG_ACCOUNT_MANAGER', 'ADMIN_AGENCY', 'OPERATION_MANAGER']
          }
        }
      })
      .state('app.admin.gameDevelopers.index', {
        url: '',
        template: '<game-developers-index></game-developers-index>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.admin.gameDevelopers.index');
          }
        }
      })
      .state('app.admin.gameDevelopers.new', {
        url: '/new',
        template: '<game-developers-edit></game-developers-edit>',
        resolve: {
          $title: ($filter) => {
            return $filter('translate')('$state.app.admin.gameDevelopers.new');
          }
        }
      })
      .state('app.admin.gameDevelopers.edit', {
        url: '/:id',
        template: '<game-developers-edit></game-developers-edit>',
        resolve: {
          $title: ($filter, $stateParams, GameDevelopersResource) => {
            return GameDevelopersResource.one($stateParams.id).get()
              .then((gameDev) => $filter('translate')('$state.app.admin.gameDevelopers.edit', {name: gameDev.company_name}));
          }
        }
      });
  })



/** WEBPACK FOOTER **
 ** ./src/components/admin/gameDevelopers/gameDevelopers.js
 **/